import React from "react";
import { useAppContext } from "../libs/contextLib";
import { slide as Menu } from "react-burger-menu";
import "./SideBar.css";

export default props => {
    const { business } = useAppContext();
    return (
        <div>
        { business && business.onboardingCompletionDate && (
        <Menu right disableAutoFocus {...props}>
            <a className="menu-item" href="/sticker">
                <span>Order More Decals</span>
            </a>
            <hr/>
            { /* <a className="menu-item" href="/story">
                <span>Edit Your Story</span>
            </a> 
            <hr/>
            */ }
            <a className="menu-item" href="/stamps">
                <span>Download Sertify Stamps</span>
            </a>
            <hr/>
            <a className="menu-item" href="/socialcontent">
                <span>Customize Your Images</span>
            </a>
            <hr/>
            <a className="menu-item" href="/logout">
                <span>Sign Out</span>
            </a>
        </Menu>
        )}
        </div>
    );
};